import React from 'react';
import creditCardLogo from '../../../../../assets/images/billing/credit-card.svg';
import stripeLogoSmall from '../../../../../assets/images/billing/stripe-logo-small.svg';

function StripeFormHeader({ title }) {
    return <div className="stripe-form-header">
        <div>
            {title || 'Pay with Credit Card'}
            <img className="stripe-form-header__icon" src={creditCardLogo} />
        </div>
        <img className="stripe-form-header__small-stripe-icon" src={stripeLogoSmall} />
    </div>;
}

export default StripeFormHeader;
